import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { NavigatorStore } from '../stores';
import { IAMessages } from '../../messages/Index';
import InstanceService from '../../../services/InstanceService';
import { IInstance } from '../../../interfaces/IInstance';
import { TargetingService } from '../../../services/TargetingService';
import UserService from '../../../services/UserService';
import { Environment } from '../../../services/Environment';
import { IUserRole } from '../../../interfaces/IUserRole';
import { INavigatorContentFromLink } from '../../../interfaces/INavigatorContentFromLink';
import { IHttpStatus } from '../../../interfaces/IHttpStatus';
import { ITargetingProperties } from '../../../interfaces/ITargetingProperties';
import { IAPanel } from '../../panels/Panel';
import { Helper } from '../../../Helper';

export interface IProps {
  navigatorStore?: NavigatorStore;
}

export interface IState {
  instance?: IInstance;
  messageToOpenSettings?: INavigatorContentFromLink;
  showPanelBeforeLoadingMessages: boolean;
  hasLoadedContent: boolean;
}

@inject('navigatorStore')
@observer
export default class MessagePanel extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      showPanelBeforeLoadingMessages: false,
      hasLoadedContent: false
    };
  }

  public componentDidMount(): void {
    window.addEventListener('popstate', () => this.openMessageFromUrl());
    this.openMessageFromUrl();
  }

  private openMessageFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const instanceName = urlParams.get("instance");
    const messageId = urlParams.get("messageId");

    if (!instanceName || !messageId) {
      return;
    }

    this.setState({ showPanelBeforeLoadingMessages: true });

    InstanceService.getInstanceIdByName(
      this.props.navigatorStore!.environment,
      this.props.navigatorStore!.token,
      this.props.navigatorStore!.tenant,
      "IntraActive-Messages",
      instanceName,
      false
    ).then(instance => {
      instance.instanceName = instance.instanceName ?? "Default";
      this.setState({ instance: instance });
      let messageToOpenSettings: INavigatorContentFromLink = {};
      messageToOpenSettings.openedFromLink = true;
      messageToOpenSettings.component = "Messages";
      messageToOpenSettings.idToOpen = parseInt(messageId);
      messageToOpenSettings.commentToShow = urlParams.get("commentId") ?? undefined;
      // Targeting
      TargetingService.getTargetingApplication(this.props.navigatorStore!.environment, this.props.navigatorStore!.tenant, this.props.navigatorStore!.token, messageToOpenSettings.component).then((targetingApplications) => {
        messageToOpenSettings.targetingApplications = targetingApplications;
        TargetingService.getProperties(this.props.navigatorStore!.environment, this.props.navigatorStore!.tenant.replace(".sharepoint.com", ""), this.props.navigatorStore!.token).then((response: { httpStatus: IHttpStatus, value?: ITargetingProperties[] }) => {
          messageToOpenSettings.targetingProperties = response.value;
          // User role
          UserService.getUserRoleForMessages(Environment.getEnvironmentForMainAPI(this.props.navigatorStore!.environment), this.props.navigatorStore!.tenant, instance?.id, "IntraActive-Messages").then((userResponse: { httpStatus: IHttpStatus, value?: IUserRole }) => {
            messageToOpenSettings.userRole = userResponse.value;
            this.setState({ messageToOpenSettings });
          });
        });
      });
    });
  }

  render() {
    let top = 0;
    if (Helper.getDisplayEnvironment() === "Sharepoint" || Helper.getDisplayEnvironment() === "SharepointClassic") {
      top = 48;
    }
    if (this.props.navigatorStore!.isMobile) {
      top = window.platform === "android" ? 50 : Helper.isIPhoneXType() ? 90 : 70;
    }
    return this.state.messageToOpenSettings ? (
      this.state.instance?.settings?.type === "reels" ? (
        <IAMessages
          environment={this.props.navigatorStore!.environment}
          tenant={this.props.navigatorStore!.tenant.indexOf(".sharepoint.com") != -1 ? this.props.navigatorStore!.tenant.replace(".sharepoint.com", "") : this.props.navigatorStore!.tenant}
          token={this.props.navigatorStore!.token}
          source="SharePoint"
          fontSlots={this.props.navigatorStore!.fontSlots}
          highlightColor={this.props.navigatorStore!.highlightColor}
          isAdminPage={false}
          isNavigator={true}
          openContentFromLink={this.state.messageToOpenSettings}
          hasOpenedContentFromLinkCallback={() => {
            this.setState({ hasLoadedContent: true });
          }}
          settings={{
            instance: this.state.instance,
          }}
        />
      ) : (
        <div id="message">
          <IAPanel
            skeletonLoaderElements={Helper.getMessagesSkeletonElements(false, this.props.navigatorStore!.isMobile)}
            open={this.state.showPanelBeforeLoadingMessages && !this.state.hasLoadedContent}
            close={() => { }}
            showNavigationBar={false}
            transition="fade"
            width={window.innerWidth < 700 ? window.innerWidth : 700}
            marginTop={top}
            loading={true}
            panelId={`preloadingPanel_${Helper.getRandomStringKey()}`}
          />
          {this.props.navigatorStore!.navigator && this.state.instance && this.state.messageToOpenSettings &&
            <IAMessages
              environment={this.props.navigatorStore!.environment}
              tenant={this.props.navigatorStore!.tenant.indexOf(".sharepoint.com") != -1 ? this.props.navigatorStore!.tenant.replace(".sharepoint.com", "") : this.props.navigatorStore!.tenant}
              token={this.props.navigatorStore!.token}
              source="SharePoint"
              fontSlots={this.props.navigatorStore!.fontSlots}
              highlightColor={this.props.navigatorStore!.highlightColor}
              isAdminPage={false}
              isNavigator={true}
              openContentFromLink={this.state.messageToOpenSettings}
              hasOpenedContentFromLinkCallback={() => {
                this.setState({ hasLoadedContent: true });
              }}
              settings={{
                instance: this.state.instance,
              }}
            />
          }
        </div>
      )
    ) : (
      <></>
    )

  }



  public componentWillUnmount(): void {
    window.removeEventListener('popstate', () => this.openMessageFromUrl());
  }
}


